module.exports = __webpack_public_path__ + "static/media/CenturyGothicRegular.e72790dd.svg";